module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "googleReviews"
    }
  }, [(_vm.place.name) ? _c('div', [_c('h2', [_vm._v(_vm._s(_vm.place.name))]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "font-italic pb-3"
  }, [_vm._v("Notes laissées par " + _vm._s(_vm.place.reviews.length) + " patients")]), _vm._v(" "), _c('v-carousel', {
    staticClass: "carousel-big-screen",
    attrs: {
      "cycle": "",
      "interval": "6000",
      "height": "38vh",
      "hide-delimiters": "",
      "hide-delimiter-background": "",
      "show-arrows-on-hover": ""
    }
  }, _vm._l((_vm.sortByDate(_vm.place.reviews)), function(item, i) {
    return _c('v-carousel-item', {
      key: i,
      staticClass: "text-center pt-2 pl-5 pr-5"
    }, [_c('div', {
      staticClass: "review-meta"
    }, [_c('p', {
      staticClass: "review-text"
    }, [_vm._v(_vm._s(item.text ? (item.text.length > 230 ? item.text.substring(0, 230) + "..." : item.text) : '( Le patient n\'a pas laissé de message )'))])]), _vm._v(" "), _c('div', {
      staticClass: "review-stars"
    }, [_c('ul', [_vm._l((Math.floor(item.rating)), function(i) {
      return _c('li', [_c('span', {
        staticClass: "star"
      })])
    }), _vm._v(" "), _vm._l(((5 - item.rating)), function(i) {
      return (item.rating < 5) ? _c('li', [_c('span', {
        class: 'star ' + (i == 0 && _vm.rating % 1 > 0 ? 'half' : 'inactive')
      })]) : _vm._e()
    })], 2)]), _vm._v(" "), _c('span', {
      staticClass: "review-author"
    }, [_vm._v(_vm._s(item.author_name))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "review-date"
    }, [_vm._v(_vm._s(item.time))])])
  }), 1), _vm._v(" "), _c('v-carousel', {
    staticClass: "carousel-small-screen",
    attrs: {
      "cycle": "",
      "interval": "6000",
      "height": "fit-content",
      "hide-delimiters": "",
      "hide-delimiter-background": "",
      "show-arrows-on-hover": ""
    }
  }, _vm._l((_vm.sortByDate(_vm.place.reviews)), function(item, i) {
    return _c('v-carousel-item', {
      key: i,
      staticClass: "text-center p-5"
    }, [_c('div', {
      staticClass: "review-meta"
    }, [_c('p', {
      staticClass: "review-text"
    }, [_vm._v(_vm._s(item.text ? (item.text.length > 450 ? item.text.substring(0, 450) + "..." : item.text) : '( Le patient n\'a pas laissé de message )'))])]), _vm._v(" "), _c('div', {
      staticClass: "review-stars"
    }, [_c('ul', [_vm._l((Math.floor(item.rating)), function(i) {
      return _c('li', [_c('span', {
        staticClass: "star"
      })])
    }), _vm._v(" "), _vm._l(((5 - item.rating)), function(i) {
      return (item.rating < 5) ? _c('li', [_c('span', {
        class: 'star ' + (i == 0 && _vm.rating % 1 > 0 ? 'half' : 'inactive')
      })]) : _vm._e()
    })], 2)]), _vm._v(" "), _c('span', {
      staticClass: "review-author"
    }, [_vm._v(_vm._s(item.author_name))]), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "review-date"
    }, [_vm._v(_vm._s(item.time))])])
  }), 1)], 1) : _c('div', {
    staticClass: "loader"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "review-stars"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "star"
  })]), _c('li', [_c('span', {
    staticClass: "star"
  })]), _c('li', [_c('span', {
    staticClass: "star"
  })]), _c('li', [_c('span', {
    staticClass: "star"
  })]), _c('li', [_c('span', {
    staticClass: "star"
  }, [_vm._v(" 5/5")])])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-351a24be", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-351a24be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/views/global/googleReviews/googleReviews.component.html
// module id = 266
// module chunks = 1